<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>

      <v-flex xs12>
        <v-card tile flat>
          <v-toolbar dense flat>
            <v-btn icon>
              <v-icon color="blue">search</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0 subheading v-subheader">
              {{ $route.query.keyword? `"${$route.query.keyword}"` : "[无检索关键词]" }} 的检索结果
            </v-toolbar-title>
          </v-toolbar>
          <v-divider/>
          <v-card-text>
            <ul
              class="section-list"
              v-if="search.items && search.items.length > 0">
              <li v-for="a in search.items" :key="a.dbid">
                <router-link :to="`/${a.section.identifier}/${a.dbid}`" target="_blank" v-html="a.title"/>
                <span v-html="a.section.name"></span>
                <span v-html="a.pubDate"></span>
              </li>
            </ul>
            <div v-else>
              [无内容]
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <!--PC端-->
      <v-flex
        xs12
        class="text-xs-center hidden-sm-and-down"
        v-if="search.items && search.items.length > 0">
        <v-pagination
          v-model="page"
          :length="length"
          :total-visible="9"
          color="blue"
          circle
        />
      </v-flex>

      <!--移动端-->
      <v-flex
        xs12
        class="text-xs-center hidden-md-and-up"
        v-if="search.items && search.items.length > 0">
        <v-pagination
          v-model="page"
          :length="length"
          :total-visible="4"
          color="blue"
          circle
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: "Search",
    data() {
      return {
        search: {},
        page: 1,
        length: 5
      }
    },
    beforeRouteEnter(to, from, next) {
      const uri = '/api/site/search';
      Vue.axios.get(uri, {params: to.query}).then(
        rsp => next(vm => {
          vm.search = rsp.data;
          vm.page = vm.search.page + 1;
          vm.length = vm.search.numberOfPages;
        })
      )
    },
    // 路由改变前，组件就已经渲染完了
    // 逻辑稍稍不同
    beforeRouteUpdate(to, from, next) {
      const uri = '/api/site/search';
      Vue.axios.get(uri, {params: to.query}).then(
        rsp => {
          this.search = rsp.data;
          this.page = this.search.page + 1;
          this.length = this.search.numberOfPages;

          next()
        }
      );
    },
    watch: {
      page(nv, ov) {
        this.$router.push(
          {
            path: '/search',
            query: {
              page: nv - 1,
              keyword: this.$route.query.keyword
            }
          }
        )
      }
    }
  }
</script>

<style scoped>
  div.card__text {
    padding: 5px 20px;
  }

  ol, ul {
    list-style: none;
  }

  li {
    display: flex;
    flex-direction: row;
    text-align: -webkit-match-parent;
    margin-bottom: .333em;
    border-bottom: 1px dashed lightgray;
    height: 1.75em;
  }

  li:last-child {
    border-bottom: none;
  }

  li > a {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    color: #333333;
  }

  li > a:visited {
    color: #333333;
  }

  li > a:hover {
    color: #1976d2;
  }

  li > span {
    width: 8em;
    text-align: right;
  }

  /* 对 Edge 无效*/
  /*li:before {*/
    /*font-family: 'Material Icons';*/
    /*content: "stop";*/
    /*font-size: 9pt;*/
    /*color: lightgrey;*/
  /*}*/

</style>

